import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTrash = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9V18C9.5 18.2761 9.27614 18.5 9 18.5C8.72386 18.5 8.5 18.2761 8.5 18V9Z' />
    <path d='M12 8.5C11.7239 8.5 11.5 8.72386 11.5 9V18C11.5 18.2761 11.7239 18.5 12 18.5C12.2761 18.5 12.5 18.2761 12.5 18V9C12.5 8.72386 12.2761 8.5 12 8.5Z' />
    <path d='M15 18.5C14.7239 18.5 14.5 18.2761 14.5 18V9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9V18C15.5 18.2761 15.2761 18.5 15 18.5Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.5 5.5H20C20.2761 5.5 20.5 5.72386 20.5 6C20.5 6.27614 20.2761 6.5 20 6.5H18.5V21.5H5.5V6.5H4C3.72386 6.5 3.5 6.27614 3.5 6C3.5 5.72386 3.72386 5.5 4 5.5H9.5V2.5H14.5V5.5ZM13.5 3.5H10.5V5.5H13.5V3.5ZM6.5 20.5V6.5H17.5V20.5H6.5Z'
    />
  </svg>
);
export default SvgTrash;
